import { Button, Heading, HStack, Spacer, Stack } from '@chakra-ui/react'
import { createFileRoute, Link } from '@tanstack/react-router'

import { Companies } from '@/corpus/Companies'

export const Route = createFileRoute('/admin/')({ component: ProductsPage })

/**
 * The corpus as it stands: every product, under the company that sells it.
 *
 * The way to add one is a link rather than a form, and it is here rather than
 * only in the sidebar because the moment an operator wants it is the moment
 * they have read this table and found it thin. That was the reason the form
 * used to sit on this page; a link keeps the reason and loses the queue.
 */
function ProductsPage() {
  return (
    <Stack gap="4" align="stretch">
      <HStack>
        <Heading size="md">Products</Heading>
        <Spacer />
        <Button asChild size="sm" variant="outline">
          <Link to="/admin/crawls">Add product</Link>
        </Button>
      </HStack>
      <Companies />
    </Stack>
  )
}
